import { render, staticRenderFns } from "./MicrolearningEditBar.vue?vue&type=template&id=491320b0&scoped=true"
import script from "./MicrolearningEditBar.vue?vue&type=script&setup=true&lang=js"
export * from "./MicrolearningEditBar.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MicrolearningEditBar.vue?vue&type=style&index=0&id=491320b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491320b0",
  null
  
)

export default component.exports